<div class="p-4 pb-3">

  <!-- Warning-only mode -->
  <ng-container *ngIf="data.warningOnly">
    <div class="d-flex align-items-center gap-2 mb-3 fw-semibold fs-5 text-danger">
      <mat-icon class="font-size">warning</mat-icon>
      <span class="font-wt">{{ data.title || 'Warning' }}</span>
    </div>

    <div class="dialog-divider"></div>

    <div class="col-md-12 col-lg-12 modalBody mb-4">
      <p class="text-secondary small mb-3">Please remove the existing file(s) and upload again:</p>
      <div class="files-section p-3 bg-light rounded-2 border">
        <ul class="file-list mb-0">
          <li *ngFor="let fileName of data.fileNames" class="file-item text-danger-primary">
            {{ fileName }}
          </li>
        </ul>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <button (click)="close('no')" class="btn-confirm">OK</button>
    </div>
  </ng-container>

  <!-- Per-file department selection mode (copy documents) -->
  <ng-container *ngIf="!data.warningOnly && data.perFileDepartments">
    <div class="d-flex align-items-center gap-2 mb-1 fw-semibold fs-5">
      <mat-icon class="font-size">content_copy</mat-icon>
      <span class="font-wt">{{ data.isBulk ? 'Copy Documents' : 'Copy Document' }}</span>
    </div>
    <p class="text-secondary small dialog-sub mb-3">Choose the department(s) each file should be copied into.</p>

    <div class="dialog-divider"></div>

    <div class="modalBody mb-4">
      <div class="files-scroll">
        <mat-accordion class="copy-accordion" displayMode="flat">
          <mat-expansion-panel *ngFor="let f of data.files; let i = index" [expanded]="i === 0" class="copy-panel">
            <mat-expansion-panel-header collapsedHeight="56px" expandedHeight="56px">
              <mat-panel-title class="copy-panel-title">
                <mat-icon class="file-glyph">description</mat-icon>
                <span class="file-item-name" [title]="f.name">{{ f.name }}</span>
              </mat-panel-title>
              <mat-panel-description class="copy-panel-desc">
                <span class="count-badge" [class.count-badge-empty]="selectedCount(f.key) === 0">{{ selectedCount(f.key) }}</span>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="dept-chips">
              <label *ngFor="let dept of data.availableDepartments" class="dept-chip"
                     [class.dept-chip-active]="isDeptChecked(f.key, dept.id)">
                <input type="checkbox" class="dept-chip-input" [checked]="isDeptChecked(f.key, dept.id)"
                       (change)="toggleDept(f.key, dept.id)">
                <mat-icon class="dept-chip-check">{{ isDeptChecked(f.key, dept.id) ? 'check_circle' : 'add_circle_outline' }}</mat-icon>
                <span class="dept-chip-text">{{ dept.name || dept.id }}</span>
              </label>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-3">
      <button (click)="confirmPerFile()" class="btn-confirm" [disabled]="!canConfirm">Copy</button>
      <button (click)="close('no')" class="btn-cancel btn-outline">Cancel</button>
    </div>
  </ng-container>

  <!-- Normal upload confirmation mode -->
  <ng-container *ngIf="!data.warningOnly && !data.perFileDepartments">
    <div class="d-flex align-items-center gap-2 mb-3 fw-semibold fs-5">
      <mat-icon class="font-size">upload_file</mat-icon>
      <span class="font-wt">
        {{ data.isBulk ? 'Upload Documents' : 'Upload Document' }}
      </span>
    </div>

    <div class="dialog-divider"></div>

    <div class="col-md-12 col-lg-12 modalBody mb-4">
      <div class="confirmation-question mb-3">
        <strong>
          Are you sure you want to upload {{ data.isBulk ? 'below files' : 'this file' }} to the following departments:?
        </strong>
      </div>

      <!-- File Names List -->
      <div class="files-section mb-3 p-3 bg-light rounded-2 border">
        <div class="section-title mb-2">
          <strong>{{ data.isBulk ? 'Files' : 'File' }}:</strong>
        </div>
        <ul class="file-list">
          <li *ngFor="let fileName of data.fileNames" class="file-item">
            {{ fileName }}
          </li>
        </ul>
      </div>

      <!-- Departments Section -->
      <div class="departments-section p-3 bg-light rounded-2 border">
        <div class="section-title mb-2">
          <strong>Departments:</strong>
        </div>
        <div class="dept-badges">
          <span *ngFor="let dept of data.departments" class="badge badge-danger-custom me-2 mb-2">
            {{ dept }}
          </span>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center gap-3">
      <button (click)="close('yes')" class="btn-confirm">Yes</button>
      <button (click)="close('no')" class="btn-cancel">No</button>
    </div>
  </ng-container>

</div>
